import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Alert } from "components/bootstrap";
import { DocumentationLink } from "components/support";
import DocsHelper from "util/DocsHelper";
const ESClusterStatus = styled(Alert)`
  margin-top: 10px;
  margin-bottom: 5px;
`;
const IndexerClusterHealthSummary = ({
  health,
  name = void 0
}) => {
  const { t } = useTranslation("indexsets");
  const formattedHealthStatus = health.status.toLowerCase();
  const alertClassForHealth = () => {
    switch (formattedHealthStatus) {
      case "green":
        return "success";
      case "yellow":
        return "warning";
      case "red":
        return "danger";
      default:
        return "success";
    }
  };
  const formattedTextForHealth = useMemo(() => {
    const text = t("indexers.cluster_health.status", {
      distribution: (name == null ? void 0 : name.distribution) || "Elasticsearch",
      name: (name == null ? void 0 : name.name) || "",
      status: formattedHealthStatus
    });
    switch (formattedHealthStatus) {
      case "green":
        return text;
      case "yellow":
      case "red":
        return /* @__PURE__ */ React.createElement("strong", null, text);
      default:
        return text;
    }
  }, [formattedHealthStatus, name, t]);
  return /* @__PURE__ */ React.createElement(ESClusterStatus, { bsStyle: alertClassForHealth() }, formattedTextForHealth, " ", t("indexers.cluster_health.shards", {
    active: health.shards.active,
    initializing: health.shards.initializing,
    relocating: health.shards.relocating,
    unassigned: health.shards.unassigned
  }), " ", /* @__PURE__ */ React.createElement(
    DocumentationLink,
    {
      page: DocsHelper.PAGES.CLUSTER_STATUS_EXPLAINED,
      text: t("indexers.cluster_health.what_does_this_mean")
    }
  ));
};
export default IndexerClusterHealthSummary;
